export const mdmCreateOfficeSiteCoreKeys = {
  createNewOfficeTitle: "MDM.Office.CreateNewOffice",
  officeDetailsSectionHeader:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader",
  officeName: "Office.CreateNewOffice.OfficeDetailsSectionHeader.OfficeName",
  parentOffice:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.ParentOffice",
  noParentDropdownOptionText:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.NoParentDropdownOptionText",
  officeCode: "Office.CreateNewOffice.OfficeDetailsSectionHeader.OfficeCode",
  officeType: "Office.CreateNewOffice.OfficeDetailsSectionHeader.OfficeType",
  market: "Office.CreateNewOffice.OfficeDetailsSectionHeader.Market",
  searchRegion:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.SearchRegion",
  billingOffice:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.BillingOffice",
  salesCreditOffice:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.SalesCreditOffice",
  currency: "Office.CreateNewOffice.OfficeDetailsSectionHeader.Currency",
  invoiceTemplate:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.InvoiceTemplate",
  salesCreditTemplate:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.SalesCreditTemplate",
  defaultTax: "Office.CreateNewOffice.OfficeDetailsSectionHeader.DefaultTax",
  status: "Office.CreateNewOffice.OfficeDetailsSectionHeader.Status",
  addressAndContactDetailsSectionHeader:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader",
  businessUnit:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.MPGBusinessUnit",
  timeZone:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.TimeZone",
  OfficeTypeList: "Office.CreateNewOffice.OfficeTypeList",
  address:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.Address",
  address1:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.Address1",
  address2:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.Address2",
  address3:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.Address3",
  addressCountry:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.Country",
  city: "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.City",
  stateOrProvince:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.StateOrProvince",
  postalCode:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.PostalCode",
  phoneNumber:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.PhoneNumber",
  emailAddress:
    "Office.CreateNewOffice.AddressAndContactDetailsSectionHeader.EmailAddress",
  editOfficeHeader: "Office.CreateNewOffice.EditOfficeHeader",
  viewOfficeHeader: "Office.CreateNewOffice.ViewOfficeHeader",
  officeSavedMessage: "Office.CreateNewOffice.OfficeSavedMessage",
  areYouSureYouWantToUpdateOffice:
    "Office.CreateNewOffice.AreYouSureYouWantToUpdateOffice",
  officeUpdatedMessage: "Office.CreateNewOffice.OfficeUpdatedMessage",
  createOfficeStatusList: "Office.CreateNewOffice.StatusList",
  officeCodeMustBeThreeDigitsMessage:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.OfficeCode.MustBe3DigitsMessage",
  selectedOptions:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.SelectedOptions",
  theSelectedParentOfficeIsCurrentlyTaggedToAChildOffice:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.TheSelectedParentOfficeIsCurrentlyTaggedToAChildOffice",
  uncheckBillingOfficeConfirmationMessage:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.UncheckBillingOfficeConfirmationMessage",
  invoicingDetailsHeader: "Office.CreateNewOffice.InvoicingDetailsHeader",
  header: "Office.CreateNewOffice.InvoicingDetailsHeader.Header",
  footerOne: "Office.CreateNewOffice.InvoicingDetailsHeader.Footer1",
  footerTwo: "Office.CreateNewOffice.InvoicingDetailsHeader.Footer2",
  footerThree: "Office.CreateNewOffice.InvoicingDetailsHeader.Footer3",
  officeAlreadyClassifiedClientMessage:
    "Office.CreateNewOffice.OfficeDetailsSectionHeader.OfficeAlreadyClassifiedClientMessage",
};

export const mdmOfficeHeaderSiteCoreKeys = {
  officeHeaderTitle: "MDM.Region.OfficeHeader",
  createNewOfficeButton: "Office.OfficeHeader.CreateNewOfficeButton",
};

export const mdmSearchOfficeSiteCoreKeys = {
  searchOfficeTitle: "MDM.Office.SearchOffice",
  officeName: "Office.SearchOffice.OfficeName",
  parentOffice: "Office.SearchOffice.ParentOffice",
  officeType: "Office.SearchOffice.OfficeType",
  market: "Office.SearchOffice.Market",
  stateOrProvince: "Office.SearchOffice.StateOrProvince",
  city: "Office.SearchOffice.City",
  status: "Office.SearchOffice.Status",
  filterByList: "Office.SearchOffice.FilterByList",
  statusList: "Office.SearchOffice.StatusList",
  officeTypeList: "Office.SearchOffice.OfficeTypeList",
  country: "Office.SearchOffice.Country",
};

export const mdmOfficeResultSiteCoreKeys = {
  officeResultsTitle: "MDM.Office.Results",
  allOfficeSectionHeading: "Office.Results.AllOfficeSectionHeading",
  officeName: "Office.Results.OfficeName",
  parentOffice: "Office.Results.ParentOffice",
  officeCode: "Office.Results.OfficeCode",
  officeType: "Office.Results.OfficeType",
  city: "Office.Results.City",
  stateOrProvince: "Office.Results.StateOrProvince",
  market: "Office.Results.Market",
  status: "Office.Results.Status",
  country: "Office.Results.Country",
  action: "Office.Results.Action",
  areYouSureYouWantToDeleteTheOffice:
    "Office.Results.AreYouSureYouWantToDeleteTheOffice",
  officeDeletedMessage: "Office.Results.OfficeDeletedMessage",
  resultStatusList: "Office.Results.StatusList",
  officeTypeList: "Office.Results.OfficeTypeList",
};
